export default __webpack_public_path__ + "static/media/alert-illustration.d3af70e9.png";